import { makeStyles } from "@material-ui/core/styles";

export const drawerWidth = 280;
export const drawerWithSmallSize = 240;

export const drawerMenuStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  drawer: {
    "& .MuiDrawer-paperAnchorDockedLeft": {
      borderRight: "none",
    },
    [theme.breakpoints.up("md")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
    [theme.breakpoints.down("md")]: {
      width: drawerWithSmallSize,
      flexShrink: 0,
    },
  },
  appBar: {
    backgroundColor: "white",
    paddingLeft: "0px",
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    [theme.breakpoints.down("md")]: {
      width: `calc(100% - ${drawerWithSmallSize}px)`,
    },
    [theme.breakpoints.down("sm")]: {
      width: `100%`,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  toolbar: {
    display: "block",
    padding: "0px",
  },
  drawerPaper: {
    backgroundColor: "#FAFBFC",
    [theme.breakpoints.up("md")]: {
      width: drawerWidth,
    },
    [theme.breakpoints.only("md")]: {
      width: drawerWithSmallSize,
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      top: "72px",
    },
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    backgroundColor: "#FAFBFC",
    padding: theme.spacing(3),
    marginTop: "128px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "72px",
    },
  },
  mainContainer: {
    backgroundColor: "#FFFFFF",
  },
  marginWithBanner: {
    marginTop: "230px",
    "& .makeStyles-content-9": {
      backgroundColor: "#FFFFFF",
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: "136px",
    },
  },
  logoContainer: {
    padding: "15px 0px 0px 29px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  footerOptions: {
    textDecoration: "none",
    fontWeight: 400,
    color: "#666666",
    "& .menuOptions": {
      "&:hover": {
        color: "#666666",
        cursor: "pointer",
      },
    },
  },
  optionSelected: {
    color: "#4187B6 !important",
  },
  emailLink: () => ({
    fontFamily: "Lato",
    textDecoration: "none",
    color: "#666666",
    fontSize: theme.typography.pxToRem(14),
    padding: "5px",
    fontWeight: 500,
    "&:hover": {
      color: "#4187B6",
      cursor: "pointer",
    },
  }),
  scoreMobile: {
    display: "flex",
    flexWrap: "nowrap",
    justifyContent: "space-between",
    marginBlock: "0.2rem",
    paddingInline: 12,
    "& .MuiTypography-root, div": {
      color: "#000",
    },
    "& .MuiTypography-root": {
      fontSize: theme.typography.pxToRem(14),
    },

    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  childrenContainer: {
    flex: "1 0 auto",
  },
  learningImageContainer: {
    position: "absolute",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
    },
  },
  learningImage: {
    width: "100%",
    [theme.breakpoints.only("xs")]: {
      marginTop: "128px",
      height: "180px",
    },
    [theme.breakpoints.only("sm")]: {
      marginTop: "75px",
      height: "280px",
    },
    [theme.breakpoints.only("md")]: {
      marginTop: "50px",
      maxHeight: "611px",
    },
    [theme.breakpoints.up("md")]: {
      marginTop: "50px",
      maxHeight: "611px",
    },
  },
  icon: {
    marginRight: "10px",
    fontSize: "1.8rem",
  },
  profileScreen: {
    padding: "0px 10px 80px 12px",
    "& .MuiTypography-button": {
      textTransform: "capitalize",
      padding: "0px 20px 0px 20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: theme.typography.pxToRem(22),
      fontWeight: 600,

      "& span": {
        display: "flex",
        alignItems: "center",
      },
    },
    "& .settings": {
      height: "21px",
      width: "21px",
      right: "0px",
      cursor: "pointer",
    },
  },
  divider: {
    width: "100%",
  },
}));
